import styled from 'styled-components';

export const DivContent = styled.div`
  width: 406px;
  margin: 0 auto;
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 1px 2px 0px #00000033;
  border: 1px solid #d8d8d8;
  font-weight: 600;
  font-size: 14px;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;

  @media (max-width: 650px) {
    width: 100%;
    margin: 0 auto;
  }

  .button,
  .link,
  .buttonActionList,
  .buttonSubscriptionActionList,
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 16px 24px 16px 24px !important;

    @media (max-width: 650px) {
      padding: 20px !important;
    }

    > div:first-child {
      display: flex;
      color: #000000;
      > img + p,
      > p {
        width: auto;
        margin-left: 16px;
      }
    }
    > p {
      margin: 0;
      color: #000000;
      line-height: 24px;
      font-weight: 700;
      font-size: 16px;
    }
  }

  .link {
    text-decoration: none;
  }

  .button,
  .buttonSubscriptionActionList,
  .buttonActionList {
    background: none;
    border: none;
    padding: 0;
    width: 100%;
    font-weight: bold;
  }

  .button {
    color: #666666;
    div {
      &:not(:first-child) {
        text-align: start;
      }
    }
  }

  .buttonActionList {
    height: 57px;
    > p {
      margin: 0;
    }
  }

  .buttonSubscriptionActionList {
    height: 63px;
    > p {
      margin: 0;
    }
  }

  > hr {
    margin: 0;
    height: 1px;
    background-color: #e6e6e6;
    border: none;
    width: 88%;
    align-self: center;
  }
`;
